import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const VirtualConnectionDownstreamSheetsFilteredByTableQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamSheetsFilteredByTableQuery(
  $vizportalUrlId: String!,
  $selectedTableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: SheetSortOrder!
) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    tablesConnection(filter: { id: $selectedTableId }) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
